import { useState, useRef } from "react";
import Button from "@/components/common/Button";
import CorporateInfo from "@/pages/settings/components/manage_orgnization/Corporate_Info";
import SubscriptionDetails from "@/pages/settings/components/manage_orgnization/Subscription_Details";
import PaymentOption from "@/pages/settings/components/manage_orgnization/Payment_Option";
import { useSelector } from "react-redux";
import { selectUserProfile } from "@/store/redux/slices/user/user_slice";
import Breadcrumb from "@/components/specific/Breadcrumb";

const ManageOrganization = () => {
  const [activeTab, setActiveTab] = useState("corporate");
  const userProfile = useSelector(selectUserProfile);
  const [selectedPlan, setSelectedPlan] = useState(null);

  // Define breadcrumb items for ManageOrganization
  const breadcrumbItems = [
    { title: "Manage Organization", path: "/settings/manage-organization" },
  ];

  const handleUpdate = async () => {
    switch (activeTab) {
      case "corporate":
        // We'll get this reference through a ref
        if (corporateInfoRef.current) {
          await corporateInfoRef.current.handleSubmit();
        }
        break;
      case "subscription":
        // Handle subscription update
        if (subscriptionRef.current) {
          await subscriptionRef.current.handleSubmit();
        }
        break;
      case "payment":
        // Handle payment update
        if (paymentRef.current) {
          await paymentRef.current.handleSubmit();
        }
        break;
      default:
        break;
    }
  };

  // Add refs for each component
  const corporateInfoRef = useRef();
  const subscriptionRef = useRef();
  const paymentRef = useRef();

  return (
    <div className="text-left">
      <div className="mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <h1 className="mb-2 heading-large text-black">
        {activeTab === "corporate"
          ? "Manage Organization"
          : activeTab === "subscription"
          ? "Subscription Details"
          : "Payment Options"}
      </h1>

      <div className="flex items-center justify-between gap-10">
        <div className="flex gap-2">
          <Button
            text="Corporate Info"
            customBgColor={activeTab === "corporate" ? "primary" : "white"}
            customTextColor={activeTab === "corporate" ? "white" : "primary"}
            className="w-[130px] h-[37px] text-small-xs whitespace-nowrap border border-primary"
            onClick={() => setActiveTab("corporate")}
          />
          <Button
            text="Subscription"
            customBgColor={activeTab === "subscription" ? "primary" : "white"}
            customTextColor={activeTab === "subscription" ? "white" : "primary"}
            className="w-[130px] h-[37px] text-small-xs whitespace-nowrap border border-primary"
            onClick={() => setActiveTab("subscription")}
          />
          <Button
            text="Payment Option"
            customBgColor={activeTab === "payment" ? "primary" : "white"}
            customTextColor={activeTab === "payment" ? "white" : "primary"}
            className="w-[130px] h-[37px] text-small-xs whitespace-nowrap border border-primary"
            onClick={() => setActiveTab("payment")}
          />
        </div>
        {activeTab !== "subscription" && (
          <Button
            text="Update Info"
            customBgColor="primary"
            customTextColor="white"
            className="w-[111px] h-[34px] text-small-xs whitespace-nowrap hidden lg:flex"
            onClick={handleUpdate}
          />
        )}
      </div>

      {activeTab === "corporate" && (
        <CorporateInfo ref={corporateInfoRef} userProfile={userProfile} />
      )}
      {activeTab === "subscription" && (
        <SubscriptionDetails
          ref={subscriptionRef}
          setActiveTab={setActiveTab}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
        />
      )}
      {activeTab === "payment" && <PaymentOption ref={paymentRef} />}

      {/* mobile update info button */}
      {activeTab !== "subscription" && (
        <Button
          text="Update Info"
          customTextColor="white"
          customBgColor="primary"
          className="w-full text-xs lg:hidden mt-6"
          onClick={handleUpdate}
        />
      )}
    </div>
  );
};

// Add display name
ManageOrganization.displayName = "ManageOrganization";

export default ManageOrganization;
